// extracted by mini-css-extract-plugin
export default {"links":"LinkTree_links__2MFjN","link":"LinkTree_link__biOyb"};